import {Box} from 'src/design/atoms/Box';
import React from 'react';
import {getUrlWithEncodingAndAuth} from 'src/shared/utils/urlHelpers';

export interface FormReferenceImageSectionProps {
  imageUrl: string | undefined;
  accessToken: string | undefined;
}

export const FormReferenceImageSection: React.FC<
  FormReferenceImageSectionProps
> = ({imageUrl, accessToken}) => {
  if (!imageUrl) return null;

  return (
    <Box
      ml="md"
      mt="md"
      data-testid="form-reference-image"
      style={{
        width: '300px',
        color: '#333',
        fontSize: 10,
      }}>
      <Box style={{textAlign: 'center'}}>Reference Image</Box>
      <img
        src={getUrlWithEncodingAndAuth(imageUrl, accessToken)}
        style={{width: 'inherit', border: '1px solid #ccc'}}
        alt="new"
      />
    </Box>
  );
};

FormReferenceImageSection.displayName = 'FormReferenceImageSection';
